import { cn } from "@/src/lib/utils";
import { InfoIcon } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "../ui/tooltip";
import { ReactNode } from "react";

export function WithTooltip({
  content,
  children,
  className,
  ...props
}: Omit<React.HTMLProps<HTMLSpanElement>, "content"> & { content: ReactNode }) {
  return (
    <Tooltip>
      <TooltipTrigger>
        <span {...props} className={cn("flex flex-row gap-1 items-center")}>
          {children}
          <span className="text-xs text-gray-500">
            <InfoIcon size={16} />
          </span>
        </span>
      </TooltipTrigger>
      <TooltipContent>{content}</TooltipContent>
    </Tooltip>
  );
}
